import { message, notification } from "antd";
export const useNotification = () => {
  const openToast = ({ content, type }) => message.open({ type, content });

  const openNotification = ({ title, message, type }) =>
    notification.open({
      message: title,
      description: message,
      type,
      placement: "topRight",
    });

  return { openToast, openNotification };
};
